[
  {
    "code": "AR-B-AA",
    "name": "Adolfo Alsina"
  },
  {
    "code": "AR-R-AA",
    "name": "Adolfo Alsina"
  },
  {
    "code": "AR-B-AC",
    "name": "Adolfo Gonzales Chaves"
  },
  {
    "code": "AR-G-AG",
    "name": "Aguirre"
  },
  {
    "code": "AR-J-AL",
    "name": "Albardón"
  },
  {
    "code": "AR-G-AL",
    "name": "Alberdi"
  },
  {
    "code": "AR-B-AL",
    "name": "Alberti"
  },
  {
    "code": "AR-B-AB",
    "name": "Almirante Brown"
  },
  {
    "code": "AR-H-AB",
    "name": "Almirante Brown"
  },
  {
    "code": "AR-Q-AL",
    "name": "Aluminé"
  },
  {
    "code": "AR-K-AM",
    "name": "Ambato"
  },
  {
    "code": "AR-B-AM",
    "name": "Ameghino"
  },
  {
    "code": "AR-K-AC",
    "name": "Ancasti"
  },
  {
    "code": "AR-K-AG",
    "name": "Andalgalá"
  },
  {
    "code": "AR-J-AN",
    "name": "Angaco"
  },
  {
    "code": "AR-A-AN",
    "name": "Anta"
  },
  {
    "code": "AR-K-AS",
    "name": "Antofagasta de la Sierra"
  },
  {
    "code": "AR-N-AP",
    "name": "Apóstoles"
  },
  {
    "code": "AR-F-AR",
    "name": "Arauco"
  },
  {
    "code": "AR-B-BM",
    "name": "Arrecifes"
  },
  {
    "code": "AR-G-AT",
    "name": "Atamisqui"
  },
  {
    "code": "AR-L-AT",
    "name": "Atreucó"
  },
  {
    "code": "AR-B-AV",
    "name": "Avellaneda"
  },
  {
    "code": "AR-R-AV",
    "name": "Avellaneda"
  },
  {
    "code": "AR-G-AV",
    "name": "Avellaneda"
  },
  {
    "code": "AR-B-AY",
    "name": "Ayacucho"
  },
  {
    "code": "AR-D-AY",
    "name": "Ayacucho"
  },
  {
    "code": "AR-B-AZ",
    "name": "Azul"
  },
  {
    "code": "AR-Q-AN",
    "name": "Añelo"
  },
  {
    "code": "AR-B-BB",
    "name": "Bahía Blanca"
  },
  {
    "code": "AR-B-BC",
    "name": "Balcarce"
  },
  {
    "code": "AR-G-BA",
    "name": "Banda"
  },
  {
    "code": "AR-B-BD",
    "name": "Baradero"
  },
  {
    "code": "AR-R-BA",
    "name": "Bariloche"
  },
  {
    "code": "AR-S-BE",
    "name": "Belgrano"
  },
  {
    "code": "AR-D-BE",
    "name": "Belgrano"
  },
  {
    "code": "AR-G-BE",
    "name": "Belgrano"
  },
  {
    "code": "AR-W-BV",
    "name": "Bella Vista"
  },
  {
    "code": "AR-K-BE",
    "name": "Belén"
  },
  {
    "code": "AR-B-BJ",
    "name": "Benito Juárez"
  },
  {
    "code": "AR-B-BZ",
    "name": "Berazategui"
  },
  {
    "code": "AR-B-BS",
    "name": "Berisso"
  },
  {
    "code": "AR-H-BE",
    "name": "Bermejo"
  },
  {
    "code": "AR-P-BE",
    "name": "Bermejo"
  },
  {
    "code": "AR-W-BA",
    "name": "Berón de Astrada"
  },
  {
    "code": "AR-U-BI",
    "name": "Biedma"
  },
  {
    "code": "AR-B-BO",
    "name": "Bolívar"
  },
  {
    "code": "AR-B-BG",
    "name": "Bragado"
  },
  {
    "code": "AR-B-BR",
    "name": "Brandsen"
  },
  {
    "code": "AR-T-BU",
    "name": "Burruyacú"
  },
  {
    "code": "AR-A-CA",
    "name": "Cachi"
  },
  {
    "code": "AR-A-CF",
    "name": "Cafayate"
  },
  {
    "code": "AR-N-CG",
    "name": "Cainguás"
  },
  {
    "code": "AR-X-CA",
    "name": "Calamuchita"
  },
  {
    "code": "AR-L-CL",
    "name": "Caleu Caleu"
  },
  {
    "code": "AR-J-CL",
    "name": "Calingasta"
  },
  {
    "code": "AR-B-CM",
    "name": "Campana"
  },
  {
    "code": "AR-N-CD",
    "name": "Candelaria"
  },
  {
    "code": "AR-K-CA",
    "name": "Capayán"
  },
  {
    "code": "AR-F-LR",
    "name": "Capital"
  },
  {
    "code": "AR-W-CN",
    "name": "Capital"
  },
  {
    "code": "AR-G-SE",
    "name": "Capital"
  },
  {
    "code": "AR-K-CT",
    "name": "Capital"
  },
  {
    "code": "AR-J-SJ",
    "name": "Capital"
  },
  {
    "code": "AR-M-MZ",
    "name": "Capital"
  },
  {
    "code": "AR-N-PS",
    "name": "Capital"
  },
  {
    "code": "AR-X-CB",
    "name": "Capital"
  },
  {
    "code": "AR-L-SR",
    "name": "Capital"
  },
  {
    "code": "AR-Y-CA",
    "name": "Capital"
  },
  {
    "code": "AR-A-SA",
    "name": "Capital"
  },
  {
    "code": "AR-T-TM",
    "name": "Capital"
  },
  {
    "code": "AR-B-CS",
    "name": "Capitán Sarmiento"
  },
  {
    "code": "AR-B-CC",
    "name": "Carlos Casares"
  },
  {
    "code": "AR-B-CT",
    "name": "Carlos Tejedor"
  },
  {
    "code": "AR-B-CA",
    "name": "Carmen de Areco"
  },
  {
    "code": "AR-S-CR",
    "name": "Caseros"
  },
  {
    "code": "AR-S-CL",
    "name": "Castellanos"
  },
  {
    "code": "AR-B-CI",
    "name": "Castelli"
  },
  {
    "code": "AR-F-CB",
    "name": "Castro Barros"
  },
  {
    "code": "AR-L-CA",
    "name": "Catriló"
  },
  {
    "code": "AR-Q-CL",
    "name": "Catán Lil"
  },
  {
    "code": "AR-J-CC",
    "name": "Caucete"
  },
  {
    "code": "AR-B-CL",
    "name": "Cañuelas"
  },
  {
    "code": "AR-A-CE",
    "name": "Cerrillos"
  },
  {
    "code": "AR-H-CH",
    "name": "Chacabuco"
  },
  {
    "code": "AR-B-CB",
    "name": "Chacabuco"
  },
  {
    "code": "AR-D-CH",
    "name": "Chacabuco"
  },
  {
    "code": "AR-L-CH",
    "name": "Chalileo"
  },
  {
    "code": "AR-F-CM",
    "name": "Chamical"
  },
  {
    "code": "AR-L-CP",
    "name": "Chapaleufú"
  },
  {
    "code": "AR-B-CH",
    "name": "Chascomús"
  },
  {
    "code": "AR-L-CC",
    "name": "Chical Có"
  },
  {
    "code": "AR-T-CH",
    "name": "Chicligasta"
  },
  {
    "code": "AR-A-CH",
    "name": "Chicoana"
  },
  {
    "code": "AR-F-CL",
    "name": "Chilecito"
  },
  {
    "code": "AR-J-CH",
    "name": "Chimbas"
  },
  {
    "code": "AR-B-CV",
    "name": "Chivilcoy"
  },
  {
    "code": "AR-Q-CM",
    "name": "Chos Malal"
  },
  {
    "code": "AR-G-CH",
    "name": "Choya"
  },
  {
    "code": "AR-Y-CO",
    "name": "Cochinoca"
  },
  {
    "code": "AR-Q-CC",
    "name": "Collón Curá"
  },
  {
    "code": "AR-B-CO",
    "name": "Colón"
  },
  {
    "code": "AR-X-CO",
    "name": "Colón"
  },
  {
    "code": "AR-E-CO",
    "name": "Colón"
  },
  {
    "code": "AR-H-CF",
    "name": "Comandante Fernández"
  },
  {
    "code": "AR-W-CO",
    "name": "Concepción"
  },
  {
    "code": "AR-N-CO",
    "name": "Concepción"
  },
  {
    "code": "AR-E-CC",
    "name": "Concordia"
  },
  {
    "code": "AR-R-CO",
    "name": "Conesa"
  },
  {
    "code": "AR-Q-CO",
    "name": "Confluencia"
  },
  {
    "code": "AR-L-CO",
    "name": "Conhelo"
  },
  {
    "code": "AR-S-CO",
    "name": "Constitución"
  },
  {
    "code": "AR-G-CO",
    "name": "Copo"
  },
  {
    "code": "AR-B-CR",
    "name": "Coronel de Marina Leonardo Rosales"
  },
  {
    "code": "AR-B-CD",
    "name": "Coronel Dorrego"
  },
  {
    "code": "AR-F-CF",
    "name": "Coronel Felipe Varela"
  },
  {
    "code": "AR-B-CP",
    "name": "Coronel Pringles"
  },
  {
    "code": "AR-D-CP",
    "name": "Coronel Pringles"
  },
  {
    "code": "AR-B-CE",
    "name": "Coronel Suárez"
  },
  {
    "code": "AR-Z-CA",
    "name": "Corpen Aike"
  },
  {
    "code": "AR-T-CA",
    "name": "Cruz Alta"
  },
  {
    "code": "AR-X-CE",
    "name": "Cruz del Eje"
  },
  {
    "code": "AR-L-CU",
    "name": "Curacó"
  },
  {
    "code": "AR-W-CC",
    "name": "Curuzú Cuatiá"
  },
  {
    "code": "AR-U-CU",
    "name": "Cushamen"
  },
  {
    "code": "AR-B-DA",
    "name": "Daireaux"
  },
  {
    "code": "AR-Z-DE",
    "name": "Deseado"
  },
  {
    "code": "AR-E-DI",
    "name": "Diamante"
  },
  {
    "code": "AR-C-DF",
    "name": "Distrito Federal"
  },
  {
    "code": "AR-H-DC",
    "name": "Doce de Octubre"
  },
  {
    "code": "AR-B-DO",
    "name": "Dolores"
  },
  {
    "code": "AR-K-EA",
    "name": "El Alto"
  },
  {
    "code": "AR-Y-EC",
    "name": "El Carmen"
  },
  {
    "code": "AR-R-EC",
    "name": "El Cuy"
  },
  {
    "code": "AR-N-ED",
    "name": "Eldorado"
  },
  {
    "code": "AR-W-EM",
    "name": "Empedrado"
  },
  {
    "code": "AR-B-EN",
    "name": "Ensenada"
  },
  {
    "code": "AR-U-ES",
    "name": "Escalante"
  },
  {
    "code": "AR-B-ES",
    "name": "Escobar"
  },
  {
    "code": "AR-W-ES",
    "name": "Esquina"
  },
  {
    "code": "AR-B-EB",
    "name": "Esteban Echeverría"
  },
  {
    "code": "AR-B-EC",
    "name": "Exaltación de la Cruz"
  },
  {
    "code": "AR-T-FA",
    "name": "Famaillá"
  },
  {
    "code": "AR-F-FA",
    "name": "Famatina"
  },
  {
    "code": "AR-E-FC",
    "name": "Federación"
  },
  {
    "code": "AR-E-FE",
    "name": "Federal"
  },
  {
    "code": "AR-E-FL",
    "name": "Feliciano"
  },
  {
    "code": "AR-G-FI",
    "name": "Figueroa"
  },
  {
    "code": "AR-B-FC",
    "name": "Florencio Varela"
  },
  {
    "code": "AR-U-FA",
    "name": "Florentino Ameghino"
  },
  {
    "code": "AR-P-FO",
    "name": "Formosa"
  },
  {
    "code": "AR-H-FJ",
    "name": "Fray Justo Santa María de Oro"
  },
  {
    "code": "AR-K-FE",
    "name": "Fray Mamerto Esquiú"
  },
  {
    "code": "AR-U-FU",
    "name": "Futaleufú"
  },
  {
    "code": "AR-U-GM",
    "name": "Gaiman"
  },
  {
    "code": "AR-S-GA",
    "name": "Garay"
  },
  {
    "code": "AR-U-GS",
    "name": "Gastre"
  },
  {
    "code": "AR-B-GD",
    "name": "General Alvarado"
  },
  {
    "code": "AR-B-GA",
    "name": "General Alvear"
  },
  {
    "code": "AR-W-GA",
    "name": "General Alvear"
  },
  {
    "code": "AR-M-GA",
    "name": "General Alvear"
  },
  {
    "code": "AR-F-GP",
    "name": "General Angel Vicente Peñaloza"
  },
  {
    "code": "AR-B-GE",
    "name": "General Arenales"
  },
  {
    "code": "AR-H-GB",
    "name": "General Belgrano"
  },
  {
    "code": "AR-B-GB",
    "name": "General Belgrano"
  },
  {
    "code": "AR-F-GB",
    "name": "General Belgrano"
  },
  {
    "code": "AR-H-GD",
    "name": "General Donovan"
  },
  {
    "code": "AR-B-GG",
    "name": "General Guido"
  },
  {
    "code": "AR-H-GG",
    "name": "General Güemes"
  },
  {
    "code": "AR-A-GG",
    "name": "General Güemes"
  },
  {
    "code": "AR-A-GM",
    "name": "General José de San Martín"
  },
  {
    "code": "AR-F-GQ",
    "name": "General Juan Facundo Quiroga"
  },
  {
    "code": "AR-B-GJ",
    "name": "General Juan Madariaga"
  },
  {
    "code": "AR-B-GM",
    "name": "General La Madrid"
  },
  {
    "code": "AR-F-GL",
    "name": "General Lamadrid"
  },
  {
    "code": "AR-B-GH",
    "name": "General Las Heras"
  },
  {
    "code": "AR-B-GL",
    "name": "General Lavalle"
  },
  {
    "code": "AR-S-GL",
    "name": "General López"
  },
  {
    "code": "AR-N-GB",
    "name": "General Manuel Belgrano"
  },
  {
    "code": "AR-S-GO",
    "name": "General Obligado"
  },
  {
    "code": "AR-F-GO",
    "name": "General Ortiz de Ocampo"
  },
  {
    "code": "AR-B-GZ",
    "name": "General Paz"
  },
  {
    "code": "AR-W-GP",
    "name": "General Paz"
  },
  {
    "code": "AR-D-GP",
    "name": "General Pedernera"
  },
  {
    "code": "AR-B-GI",
    "name": "General Pinto"
  },
  {
    "code": "AR-B-GP",
    "name": "General Pueyrredón"
  },
  {
    "code": "AR-R-GR",
    "name": "General Roca"
  },
  {
    "code": "AR-X-GR",
    "name": "General Roca"
  },
  {
    "code": "AR-B-GR",
    "name": "General Rodríguez"
  },
  {
    "code": "AR-B-GN",
    "name": "General San Martín"
  },
  {
    "code": "AR-F-GM",
    "name": "General San Martín"
  },
  {
    "code": "AR-X-GM",
    "name": "General San Martín"
  },
  {
    "code": "AR-B-GS",
    "name": "General Sarmiento"
  },
  {
    "code": "AR-G-GT",
    "name": "General Taboada"
  },
  {
    "code": "AR-B-GT",
    "name": "General Viamonte"
  },
  {
    "code": "AR-B-GV",
    "name": "General Villegas"
  },
  {
    "code": "AR-D-GD",
    "name": "Gobernador Dupuy"
  },
  {
    "code": "AR-M-GC",
    "name": "Godoy Cruz"
  },
  {
    "code": "AR-W-GO",
    "name": "Goya"
  },
  {
    "code": "AR-T-GR",
    "name": "Graneros"
  },
  {
    "code": "AR-A-GU",
    "name": "Guachipas"
  },
  {
    "code": "AR-E-GG",
    "name": "Gualeguay"
  },
  {
    "code": "AR-E-GC",
    "name": "Gualeguaychú"
  },
  {
    "code": "AR-B-GU",
    "name": "Guaminí"
  },
  {
    "code": "AR-N-GU",
    "name": "Guaraní"
  },
  {
    "code": "AR-G-GU",
    "name": "Guasayán"
  },
  {
    "code": "AR-L-GU",
    "name": "Guatraché"
  },
  {
    "code": "AR-M-GU",
    "name": "Guaymallén"
  },
  {
    "code": "AR-Z-GA",
    "name": "Güer Aike"
  },
  {
    "code": "AR-B-HY",
    "name": "Hipólito Yrigoyen"
  },
  {
    "code": "AR-L-HU",
    "name": "Hucal"
  },
  {
    "code": "AR-Q-HU",
    "name": "Huiliches"
  },
  {
    "code": "AR-Y-HU",
    "name": "Humahuaca"
  },
  {
    "code": "AR-J-IG",
    "name": "Iglesia"
  },
  {
    "code": "AR-N-IG",
    "name": "Iguazú"
  },
  {
    "code": "AR-H-IN",
    "name": "Independencia"
  },
  {
    "code": "AR-F-IN",
    "name": "Independencia"
  },
  {
    "code": "AR-S-IR",
    "name": "Iriondo"
  },
  {
    "code": "AR-A-IR",
    "name": "Iruya"
  },
  {
    "code": "AR-X-IS",
    "name": "Ischilín"
  },
  {
    "code": "AR-E-IS",
    "name": "Isla"
  },
  {
    "code": "AR-E-II",
    "name": "Islas del Ibicuy"
  },
  {
    "code": "AR-W-IT",
    "name": "Itatí"
  },
  {
    "code": "AR-W-IZ",
    "name": "Ituzaingó"
  },
  {
    "code": "AR-G-JM",
    "name": "Jiménez"
  },
  {
    "code": "AR-T-JA",
    "name": "Juan B. Alberdi"
  },
  {
    "code": "AR-G-JI",
    "name": "Juan Felipe Ibarra"
  },
  {
    "code": "AR-B-JU",
    "name": "Junín"
  },
  {
    "code": "AR-D-JU",
    "name": "Junín"
  },
  {
    "code": "AR-M-JU",
    "name": "Junín"
  },
  {
    "code": "AR-X-JC",
    "name": "Juárez Celman"
  },
  {
    "code": "AR-J-JA",
    "name": "Jáchal"
  },
  {
    "code": "AR-A-LC",
    "name": "La Caldera"
  },
  {
    "code": "AR-A-LD",
    "name": "La Candelaria"
  },
  {
    "code": "AR-S-LP",
    "name": "La Capital"
  },
  {
    "code": "AR-D-LC",
    "name": "La Capital"
  },
  {
    "code": "AR-T-LC",
    "name": "La Cocha"
  },
  {
    "code": "AR-B-LC",
    "name": "La Costa"
  },
  {
    "code": "AR-B-LM",
    "name": "La Matanza"
  },
  {
    "code": "AR-E-LP",
    "name": "La Paz"
  },
  {
    "code": "AR-M-LP",
    "name": "La Paz"
  },
  {
    "code": "AR-K-LP",
    "name": "La Paz"
  },
  {
    "code": "AR-B-LT",
    "name": "La Plata"
  },
  {
    "code": "AR-A-LP",
    "name": "La Poma"
  },
  {
    "code": "AR-A-LV",
    "name": "La Viña"
  },
  {
    "code": "AR-Q-LA",
    "name": "Lacar"
  },
  {
    "code": "AR-Z-LA",
    "name": "Lago Argentino"
  },
  {
    "code": "AR-Z-LB",
    "name": "Lago Buenos Aires"
  },
  {
    "code": "AR-P-LA",
    "name": "Laishi"
  },
  {
    "code": "AR-U-LA",
    "name": "Languiñeo"
  },
  {
    "code": "AR-B-LS",
    "name": "Lanús"
  },
  {
    "code": "AR-B-LR",
    "name": "Laprida"
  },
  {
    "code": "AR-S-LC",
    "name": "Las Colonias"
  },
  {
    "code": "AR-B-LF",
    "name": "Las Flores"
  },
  {
    "code": "AR-M-LH",
    "name": "Las Heras"
  },
  {
    "code": "AR-M-LA",
    "name": "Lavalle"
  },
  {
    "code": "AR-W-LA",
    "name": "Lavalle"
  },
  {
    "code": "AR-T-LE",
    "name": "Leales"
  },
  {
    "code": "AR-B-LA",
    "name": "Leandro N. Alem"
  },
  {
    "code": "AR-N-LA",
    "name": "Leandro N. Alem"
  },
  {
    "code": "AR-Y-LE",
    "name": "Ledesma"
  },
  {
    "code": "AR-H-LI",
    "name": "Libertad"
  },
  {
    "code": "AR-H-LM",
    "name": "Libertador General San Martín"
  },
  {
    "code": "AR-N-LM",
    "name": "Libertador General San Martín"
  },
  {
    "code": "AR-D-LM",
    "name": "Libertador General San Martín"
  },
  {
    "code": "AR-L-UC",
    "name": "Lihuel Calel"
  },
  {
    "code": "AR-L-LM",
    "name": "Limay Mahuida"
  },
  {
    "code": "AR-B-LI",
    "name": "Lincoln"
  },
  {
    "code": "AR-B-LO",
    "name": "Lobería"
  },
  {
    "code": "AR-B-LB",
    "name": "Lobos"
  },
  {
    "code": "AR-B-LZ",
    "name": "Lomas de Zamora"
  },
  {
    "code": "AR-Q-LO",
    "name": "Loncopué"
  },
  {
    "code": "AR-G-LO",
    "name": "Loreto"
  },
  {
    "code": "AR-A-LA",
    "name": "Los Andes"
  },
  {
    "code": "AR-Q-LL",
    "name": "Los Lagos"
  },
  {
    "code": "AR-L-LO",
    "name": "Loventué"
  },
  {
    "code": "AR-B-LU",
    "name": "Luján"
  },
  {
    "code": "AR-M-LC",
    "name": "Luján de Cuyo"
  },
  {
    "code": "AR-T-LU",
    "name": "Lules"
  },
  {
    "code": "AR-Z-MA",
    "name": "Magallanes"
  },
  {
    "code": "AR-B-ML",
    "name": "Magdalena"
  },
  {
    "code": "AR-H-MA",
    "name": "Maipú"
  },
  {
    "code": "AR-M-MP",
    "name": "Maipú"
  },
  {
    "code": "AR-B-MA",
    "name": "Maipú"
  },
  {
    "code": "AR-M-ML",
    "name": "Malargüe"
  },
  {
    "code": "AR-B-MC",
    "name": "Mar Chiquita"
  },
  {
    "code": "AR-L-MA",
    "name": "Maracó"
  },
  {
    "code": "AR-X-MJ",
    "name": "Marcos Juárez"
  },
  {
    "code": "AR-B-MP",
    "name": "Marcos Paz"
  },
  {
    "code": "AR-P-MA",
    "name": "Matacos"
  },
  {
    "code": "AR-H-MF",
    "name": "Mayor Luis J. Fontana"
  },
  {
    "code": "AR-W-MB",
    "name": "Mburucuyá"
  },
  {
    "code": "AR-B-MD",
    "name": "Mercedes"
  },
  {
    "code": "AR-W-ME",
    "name": "Mercedes"
  },
  {
    "code": "AR-B-ME",
    "name": "Merlo"
  },
  {
    "code": "AR-A-ME",
    "name": "Metán"
  },
  {
    "code": "AR-Q-MI",
    "name": "Minas"
  },
  {
    "code": "AR-X-MI",
    "name": "Minas"
  },
  {
    "code": "AR-G-MI",
    "name": "Mitre"
  },
  {
    "code": "AR-A-MO",
    "name": "Molinos"
  },
  {
    "code": "AR-B-MT",
    "name": "Monte"
  },
  {
    "code": "AR-W-MC",
    "name": "Monte Caseros"
  },
  {
    "code": "AR-B-MH",
    "name": "Monte Hermoso"
  },
  {
    "code": "AR-N-MO",
    "name": "Montecarlo"
  },
  {
    "code": "AR-T-MO",
    "name": "Monteros"
  },
  {
    "code": "AR-G-MO",
    "name": "Moreno"
  },
  {
    "code": "AR-B-MR",
    "name": "Moreno"
  },
  {
    "code": "AR-B-MN",
    "name": "Morón"
  },
  {
    "code": "AR-U-MA",
    "name": "Mártires"
  },
  {
    "code": "AR-B-NA",
    "name": "Navarro"
  },
  {
    "code": "AR-B-NE",
    "name": "Necochea"
  },
  {
    "code": "AR-E-NO",
    "name": "Nogoyá"
  },
  {
    "code": "AR-R-NJ",
    "name": "Nueve de Julio"
  },
  {
    "code": "AR-S-NJ",
    "name": "Nueve de Julio"
  },
  {
    "code": "AR-H-NJ",
    "name": "Nueve de Julio"
  },
  {
    "code": "AR-B-NJ",
    "name": "Nueve de Julio"
  },
  {
    "code": "AR-H-OH",
    "name": "O'Higgins"
  },
  {
    "code": "AR-N-OB",
    "name": "Oberá"
  },
  {
    "code": "AR-G-OJ",
    "name": "Ojo de Agua"
  },
  {
    "code": "AR-B-OL",
    "name": "Olavarría"
  },
  {
    "code": "AR-A-OR",
    "name": "Orán"
  },
  {
    "code": "AR-K-PA",
    "name": "Paclín"
  },
  {
    "code": "AR-Y-PA",
    "name": "Palpalá"
  },
  {
    "code": "AR-E-PA",
    "name": "Paraná"
  },
  {
    "code": "AR-U-PI",
    "name": "Paso de Indios"
  },
  {
    "code": "AR-W-PL",
    "name": "Paso de los Libres"
  },
  {
    "code": "AR-B-PA",
    "name": "Patagones"
  },
  {
    "code": "AR-P-PA",
    "name": "Patiño"
  },
  {
    "code": "AR-B-PJ",
    "name": "Pehuajó"
  },
  {
    "code": "AR-Q-PE",
    "name": "Pehuenches"
  },
  {
    "code": "AR-G-PE",
    "name": "Pellegrini"
  },
  {
    "code": "AR-B-PE",
    "name": "Pellegrini"
  },
  {
    "code": "AR-B-PG",
    "name": "Pergamino"
  },
  {
    "code": "AR-R-PM",
    "name": "Pichi Mahuida"
  },
  {
    "code": "AR-Q-PI",
    "name": "Picunches"
  },
  {
    "code": "AR-Q-PL",
    "name": "Picún Leufú"
  },
  {
    "code": "AR-B-PL",
    "name": "Pila"
  },
  {
    "code": "AR-P-PG",
    "name": "Pilagás"
  },
  {
    "code": "AR-B-PX",
    "name": "Pilar"
  },
  {
    "code": "AR-R-PI",
    "name": "Pilcaniyeu"
  },
  {
    "code": "AR-P-PM",
    "name": "Pilcomayo"
  },
  {
    "code": "AR-B-PI",
    "name": "Pinamar"
  },
  {
    "code": "AR-P-PR",
    "name": "Pirané"
  },
  {
    "code": "AR-X-PO",
    "name": "Pocho"
  },
  {
    "code": "AR-J-PO",
    "name": "Pocito"
  },
  {
    "code": "AR-K-PO",
    "name": "Pomán"
  },
  {
    "code": "AR-H-PP",
    "name": "Presidencia de la Plaza"
  },
  {
    "code": "AR-X-PP",
    "name": "Presidente Roque Sáenz Peña"
  },
  {
    "code": "AR-H-PM",
    "name": "Primero de Mayo"
  },
  {
    "code": "AR-L-PU",
    "name": "Puelén"
  },
  {
    "code": "AR-X-PU",
    "name": "Punilla"
  },
  {
    "code": "AR-B-PU",
    "name": "Puán"
  },
  {
    "code": "AR-G-QU",
    "name": "Quebrachos"
  },
  {
    "code": "AR-L-QQ",
    "name": "Quemú Quemú"
  },
  {
    "code": "AR-B-QU",
    "name": "Quilmes"
  },
  {
    "code": "AR-H-QU",
    "name": "Quitilipi"
  },
  {
    "code": "AR-B-RM",
    "name": "Ramallo"
  },
  {
    "code": "AR-P-RL",
    "name": "Ramón Lista"
  },
  {
    "code": "AR-L-RA",
    "name": "Rancul"
  },
  {
    "code": "AR-B-RU",
    "name": "Rauch"
  },
  {
    "code": "AR-J-RA",
    "name": "Rawson"
  },
  {
    "code": "AR-U-RA",
    "name": "Rawson"
  },
  {
    "code": "AR-L-RE",
    "name": "Realicó"
  },
  {
    "code": "AR-Y-RI",
    "name": "Rinconada"
  },
  {
    "code": "AR-G-RI",
    "name": "Rivadavia"
  },
  {
    "code": "AR-J-RI",
    "name": "Rivadavia"
  },
  {
    "code": "AR-M-RI",
    "name": "Rivadavia"
  },
  {
    "code": "AR-B-RI",
    "name": "Rivadavia"
  },
  {
    "code": "AR-A-RI",
    "name": "Rivadavia"
  },
  {
    "code": "AR-Z-RC",
    "name": "Rió Chico"
  },
  {
    "code": "AR-T-RC",
    "name": "Rió Chico"
  },
  {
    "code": "AR-X-RC",
    "name": "Rió Cuarto"
  },
  {
    "code": "AR-V-RG",
    "name": "Rió Grande"
  },
  {
    "code": "AR-G-RH",
    "name": "Rió Hondo"
  },
  {
    "code": "AR-X-RP",
    "name": "Rió Primero"
  },
  {
    "code": "AR-X-RS",
    "name": "Rió Seco"
  },
  {
    "code": "AR-X-RG",
    "name": "Rió Segundo"
  },
  {
    "code": "AR-U-RS",
    "name": "Rió Senguer"
  },
  {
    "code": "AR-G-RO",
    "name": "Robles"
  },
  {
    "code": "AR-B-RO",
    "name": "Rojas"
  },
  {
    "code": "AR-B-RP",
    "name": "Roque Pérez"
  },
  {
    "code": "AR-S-RO",
    "name": "Rosario"
  },
  {
    "code": "AR-A-RF",
    "name": "Rosario de la Frontera"
  },
  {
    "code": "AR-A-RL",
    "name": "Rosario de Lerma"
  },
  {
    "code": "AR-F-RP",
    "name": "Rosario Vera Peñaloza"
  },
  {
    "code": "AR-B-SD",
    "name": "Saavedra"
  },
  {
    "code": "AR-W-SL",
    "name": "Saladas"
  },
  {
    "code": "AR-B-SL",
    "name": "Saladillo"
  },
  {
    "code": "AR-G-SV",
    "name": "Salavina"
  },
  {
    "code": "AR-B-SQ",
    "name": "Salliqueló"
  },
  {
    "code": "AR-B-ST",
    "name": "Salto"
  },
  {
    "code": "AR-X-SA",
    "name": "San Alberto"
  },
  {
    "code": "AR-B-SG",
    "name": "San Andrés de Giles"
  },
  {
    "code": "AR-R-SA",
    "name": "San Antonio"
  },
  {
    "code": "AR-Y-SA",
    "name": "San Antonio"
  },
  {
    "code": "AR-B-SA",
    "name": "San Antonio de Areco"
  },
  {
    "code": "AR-F-SS",
    "name": "San Blas de los Sauces"
  },
  {
    "code": "AR-M-SC",
    "name": "San Carlos"
  },
  {
    "code": "AR-A-SC",
    "name": "San Carlos"
  },
  {
    "code": "AR-B-SC",
    "name": "San Cayetano"
  },
  {
    "code": "AR-W-SC",
    "name": "San Cosme"
  },
  {
    "code": "AR-S-SC",
    "name": "San Cristóbal"
  },
  {
    "code": "AR-H-SF",
    "name": "San Fernando"
  },
  {
    "code": "AR-B-SF",
    "name": "San Fernando Partido"
  },
  {
    "code": "AR-N-SI",
    "name": "San Ignacio"
  },
  {
    "code": "AR-B-SI",
    "name": "San Isidro"
  },
  {
    "code": "AR-X-SV",
    "name": "San Javier"
  },
  {
    "code": "AR-N-SJ",
    "name": "San Javier"
  },
  {
    "code": "AR-S-SV",
    "name": "San Javier"
  },
  {
    "code": "AR-S-SR",
    "name": "San Jerónimo"
  },
  {
    "code": "AR-X-SJ",
    "name": "San Justo"
  },
  {
    "code": "AR-S-SJ",
    "name": "San Justo"
  },
  {
    "code": "AR-H-SL",
    "name": "San Lorenzo"
  },
  {
    "code": "AR-S-SL",
    "name": "San Lorenzo"
  },
  {
    "code": "AR-W-SP",
    "name": "San Luis del Palmar"
  },
  {
    "code": "AR-G-SM",
    "name": "San Martín"
  },
  {
    "code": "AR-J-SM",
    "name": "San Martín"
  },
  {
    "code": "AR-W-SM",
    "name": "San Martín"
  },
  {
    "code": "AR-M-SM",
    "name": "San Martín"
  },
  {
    "code": "AR-S-SM",
    "name": "San Martín"
  },
  {
    "code": "AR-W-SG",
    "name": "San Miguel"
  },
  {
    "code": "AR-B-SN",
    "name": "San Nicolás"
  },
  {
    "code": "AR-N-SP",
    "name": "San Pedro"
  },
  {
    "code": "AR-Y-SP",
    "name": "San Pedro"
  },
  {
    "code": "AR-B-SP",
    "name": "San Pedro"
  },
  {
    "code": "AR-M-SR",
    "name": "San Rafael"
  },
  {
    "code": "AR-W-SR",
    "name": "San Roque"
  },
  {
    "code": "AR-B-SE",
    "name": "San Vicente"
  },
  {
    "code": "AR-F-SA",
    "name": "Sanagasta"
  },
  {
    "code": "AR-Y-SB",
    "name": "Santa Bárbara"
  },
  {
    "code": "AR-Y-SC",
    "name": "Santa Catalina"
  },
  {
    "code": "AR-J-SL",
    "name": "Santa Lucía"
  },
  {
    "code": "AR-X-SM",
    "name": "Santa María"
  },
  {
    "code": "AR-K-SM",
    "name": "Santa María"
  },
  {
    "code": "AR-M-ST",
    "name": "Santa Rosa"
  },
  {
    "code": "AR-K-SR",
    "name": "Santa Rosa"
  },
  {
    "code": "AR-A-SV",
    "name": "Santa Victoria"
  },
  {
    "code": "AR-W-ST",
    "name": "Santo Tomé"
  },
  {
    "code": "AR-H-SC",
    "name": "Sargento Cabral"
  },
  {
    "code": "AR-G-SR",
    "name": "Sarmiento"
  },
  {
    "code": "AR-J-SA",
    "name": "Sarmiento"
  },
  {
    "code": "AR-U-SA",
    "name": "Sarmiento"
  },
  {
    "code": "AR-W-SA",
    "name": "Sauce"
  },
  {
    "code": "AR-G-SI",
    "name": "Silípica"
  },
  {
    "code": "AR-T-SI",
    "name": "Simoca"
  },
  {
    "code": "AR-X-SO",
    "name": "Sobremonte"
  },
  {
    "code": "AR-B-SU",
    "name": "Suipacha"
  },
  {
    "code": "AR-Y-SU",
    "name": "Susques"
  },
  {
    "code": "AR-T-TD",
    "name": "Tafí del Valle"
  },
  {
    "code": "AR-T-TV",
    "name": "Tafí Viejo"
  },
  {
    "code": "AR-E-TA",
    "name": "Tala"
  },
  {
    "code": "AR-B-TD",
    "name": "Tandil"
  },
  {
    "code": "AR-B-TP",
    "name": "Tapalqué"
  },
  {
    "code": "AR-H-TA",
    "name": "Tapenagá"
  },
  {
    "code": "AR-U-TH",
    "name": "Tehuelches"
  },
  {
    "code": "AR-U-TN",
    "name": "Telsen"
  },
  {
    "code": "AR-X-TA",
    "name": "Tercero Arriba"
  },
  {
    "code": "AR-B-TI",
    "name": "Tigre"
  },
  {
    "code": "AR-Y-TI",
    "name": "Tilcara"
  },
  {
    "code": "AR-K-TI",
    "name": "Tinogasta"
  },
  {
    "code": "AR-L-TO",
    "name": "Toay"
  },
  {
    "code": "AR-B-TO",
    "name": "Tordillo"
  },
  {
    "code": "AR-B-TQ",
    "name": "Tornquist"
  },
  {
    "code": "AR-X-TO",
    "name": "Totoral"
  },
  {
    "code": "AR-T-TR",
    "name": "Trancas"
  },
  {
    "code": "AR-L-TR",
    "name": "Trenel"
  },
  {
    "code": "AR-B-TR",
    "name": "Trenque Lauquen"
  },
  {
    "code": "AR-B-TA",
    "name": "Tres Arroyos"
  },
  {
    "code": "AR-B-TF",
    "name": "Tres de Febrero"
  },
  {
    "code": "AR-B-TL",
    "name": "Tres Lomas"
  },
  {
    "code": "AR-X-TU",
    "name": "Tulumba"
  },
  {
    "code": "AR-Y-TU",
    "name": "Tumbaya"
  },
  {
    "code": "AR-M-TN",
    "name": "Tunuyán"
  },
  {
    "code": "AR-M-TP",
    "name": "Tupungato"
  },
  {
    "code": "AR-J-UL",
    "name": "Ullum"
  },
  {
    "code": "AR-X-UN",
    "name": "Unión"
  },
  {
    "code": "AR-E-UR",
    "name": "Uruguay"
  },
  {
    "code": "AR-V-US",
    "name": "Ushuaia"
  },
  {
    "code": "AR-L-UT",
    "name": "Utracán"
  },
  {
    "code": "AR-R-VA",
    "name": "Valcheta"
  },
  {
    "code": "AR-J-VF",
    "name": "Valle Fértil"
  },
  {
    "code": "AR-Y-VG",
    "name": "Valle Grande"
  },
  {
    "code": "AR-K-VV",
    "name": "Valle Viejo"
  },
  {
    "code": "AR-B-VM",
    "name": "Veinticinco de Mayo"
  },
  {
    "code": "AR-N-VM",
    "name": "Veinticinco de Mayo"
  },
  {
    "code": "AR-H-VM",
    "name": "Veinticinco de Mayo"
  },
  {
    "code": "AR-R-VM",
    "name": "Veinticinco de Mayo"
  },
  {
    "code": "AR-J-VM",
    "name": "Veinticinco de Mayo"
  },
  {
    "code": "AR-S-VE",
    "name": "Vera"
  },
  {
    "code": "AR-B-VL",
    "name": "Vicente López"
  },
  {
    "code": "AR-E-VC",
    "name": "Victoria"
  },
  {
    "code": "AR-B-VG",
    "name": "Villa Gesell"
  },
  {
    "code": "AR-E-VG",
    "name": "Villaguay"
  },
  {
    "code": "AR-B-VI",
    "name": "Villarino"
  },
  {
    "code": "AR-F-VI",
    "name": "Vinchina"
  },
  {
    "code": "AR-Y-YA",
    "name": "Yavi"
  },
  {
    "code": "AR-T-YB",
    "name": "Yerba Buena"
  },
  {
    "code": "AR-Q-ZA",
    "name": "Zapala"
  },
  {
    "code": "AR-J-ZO",
    "name": "Zonda"
  },
  {
    "code": "AR-B-ZA",
    "name": "Zárate"
  },
  {
    "code": "AR-R-NO",
    "name": "Ñorquinco"
  },
  {
    "code": "AR-Q-NO",
    "name": "Ñorquín"
  }
]